<template>
  <fragment>
    <search-nav-year-month label="" :use-all-year="false" type="year" :value="{ year: '', month: '' }" @input="changeYM" />
    <search-nav-item-select :label="$t('search.검색조건')" v-model="nav.searchType" :list="searchTypes"/>
    <search-nav-item-keyword :label="$t('search.키워드')" v-model="nav.searchKeyword"/>
  </fragment>
</template>

<script>
import SearchNavStartEnd from '@/components/nav/SearchNavStartEnd.vue'
import SearchNav from '@/components/nav/SearchNav'
import SearchNavItemKeyword from '@/components/nav/SearchNavItemKeyword'
import SearchNavItemSelect from '@/components/nav/SearchNavItemSelect'
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";

export default {
  name: 'NormalSearchNav688',
  components: {
    SearchNavYearMonth,
    SearchNavStartEnd,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    SearchNav,
  },
  watch: {
    nav: {
      immediate: true,
      deep: true,
      handler () {
        this.$emit('input', this.nav)
      }
    }
  },
  data () {
    return {
      nav: {
        created_at: '',

        searchType: '',
        searchKeyword: '',
      },
      searchTypes: [
        { value: '회사명' },
        { value: '점검구분' },


        { value: '작성자' },
      ],
    }
  },
  methods: {
    changeYM(value) {
      if (!value.year) {
        this.nav.year = value.year;
      }
    },
  }
}
</script>

<style scoped>

</style>
